// Module
var code = "<template show.bind=\"visible\" class=\"${disabled ? '--disabled' : ''} ${active ? '--active' : ''}\" click.trigger=\"onClick()\"> <require from=\"./item.scss\"></require> <slot></slot> </template> ";
// Exports
module.exports = code;